<div id="cutomer-eligibility-screen" [ngStyle]="{'height.px':divHeight1}">
    <div class="row no-gutters" [ngStyle]="{'height.px':divHeight1}">
        <div class="col-lg-4">
            <app-progress-tracker [stepOneIcon]="stepOneIcon" [stepOneRoleDone]="stepOneRoleDone"
                [stepOneTickIcon]="stepOneTickIcon" [stepOneDone]="stepOneDone"
                [progressTrackerStatus]="progressTrackerStatus" [verificationType]="verificationType">
            </app-progress-tracker>
        </div>
        <div class="col-lg-8" id="form-component-section">
            <router-outlet (activate)="onActivate($event)"></router-outlet>
        </div>
    </div>

    <div [ngClass]="showCancelModal ? 'open-eligibility-step-cancel-modal' : 'hide-cancel-modal'">
        <app-cancel-eligibility-step-modal [openModal]="openCancelModal" (closeModal)="closeModal($event)">
        </app-cancel-eligibility-step-modal>
    </div>
</div>